import React from "react";

const RadioField = ({ input, options }) => {
  const handleChange = (event: { target: { value: any; }; }) => {
    input.onChange(event.target.value);
  }
  return (
    <div>
      {options.map((option: { label: string; value: any }, index: number) => (
        <label key={option.value} className={`${index !== options.length - 1 ? "mr-8" : ""}`}>
          <input type="radio" {...input} value={option.value} onChange={handleChange} />
          <span className="pl-2">{option.label}</span>
        </label>
      ))}
    </div>
  );
}

export default RadioField;